import { render, staticRenderFns } from "./EmailFormCertificate.vue?vue&type=template&id=bef0f56c&scoped=true&"
import script from "./EmailFormCertificate.vue?vue&type=script&lang=js&"
export * from "./EmailFormCertificate.vue?vue&type=script&lang=js&"
import style0 from "./EmailFormCertificate.vue?vue&type=style&index=0&id=bef0f56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef0f56c",
  null
  
)

export default component.exports